import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from './ui/button';
import { X, Download } from 'lucide-react';

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

export function QRCodeModal({ isOpen, onClose, url, title }: QRCodeModalProps) {
  if (!isOpen) return null;

  const downloadQR = async () => {
    try {
      const QRCode = await import('qrcode');
      const qrDataURL = await QRCode.toDataURL(url, {
        scale: 10, // This will create a 500x500 image (50x50 QR code * 10 scale)
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });

      const downloadLink = document.createElement('a');
      downloadLink.download = `${title}-qr-code.png`;
      downloadLink.href = qrDataURL;
      downloadLink.click();
    } catch (error) {
      console.error('Error generating QR code:', error);
      alert('Erro ao gerar QR code para download');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative max-w-md w-full mx-4">
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-slate-900">QR Code</h2>
            <Button
              size="icon"
              variant="ghost"
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600"
            >
              <X className="w-6 h-6" />
            </Button>
          </div>

          <div className="flex justify-center mb-6">
            <div className="bg-white p-4 rounded-xl shadow-sm">
              <QRCodeSVG
                id="qr-code-svg"
                value={url}
                size={200}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              />
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              variant="primary"
              onClick={downloadQR}
              className="flex-1"
              icon={<Download className="w-5 h-5" />}
            >
              Baixar QR Code
            </Button>
            <Button
              variant="ghost"
              onClick={onClose}
              className="flex-1"
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
